export default __webpack_public_path__ + "static/media/T_65_mobile.60c0eaef.jpg";